import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import TrapScoreLink from "../../../../components/atoms/TrapScoreLink";
import {
  getIsSnv,
  getMainTranscript,
  getPosition,
  getChromosome,
  getRef,
  getAlt,
} from "../../../../state/selectors/general.selectors";
import HelperText from "../../../../components/atoms/HelperText";

const TrapLink = (props) => {
  const { mainTranscript, isSnv, chromosome, pos, reference, alt } = props;
  if (mainTranscript && mainTranscript.hgvs && isSnv && chromosome && pos) {
    const query = `${chromosome?.split("chr")[1]}-${pos}-${reference}-${alt}`;
    return (
      <div>
        <small>
          <TrapScoreLink trapQuery={query} showExternalIconLink={true} />
          <HelperText fieldDescriptionKey="TraP score" />
        </small>
      </div>
    );
  }
  return null;
};

TrapLink.propTypes = {
  mainTranscript: PropTypes.shape({
    name: PropTypes.string,
    strand: PropTypes.string,
    coding_impact: PropTypes.string,
    function: PropTypes.arrayOf(PropTypes.string),
    hgvs: PropTypes.string,
    hgvs_p1: PropTypes.string,
    hgvs_p3: PropTypes.string,
    location: PropTypes.string,
    coding_location: PropTypes.string,
    canonical: PropTypes.bool,
    gene_symbol: PropTypes.string,
    splice_distance: PropTypes.string,
    ensembl_support_level: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
  isSnv: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  chromosome: PropTypes.string,
  pos: PropTypes.number,
  reference: PropTypes.string,
  alt: PropTypes.string,
};

TrapLink.defaultProps = {
  mainTranscript: null,
  isSnv: false,
  chromosome: null,
  pos: null,
  reference: null,
  alt: null,
};

const mapStateToProps = (state) => ({
  mainTranscript: getMainTranscript(state),
  isSnv: getIsSnv(state),
  chromosome: getChromosome(state),
  pos: getPosition(state),
  reference: getRef(state),
  alt: getAlt(state),
});

export default connect(mapStateToProps)(TrapLink);
